export const sortAlertsByMonitorId = (alertsArray: any[]) => {
  const alerts = {};
  alertsArray.forEach((alert: any) => {
    if(alerts[alert.monitorId] === undefined) {
      alerts[alert.monitorId] = [alert];
    } else {
      alerts[alert.monitorId].push(alert);
    }
  })
  return alerts;
}






// WEBPACK FOOTER //
// ./src/utils/alerts/sortAlertsByMonitorId.ts